import React  from 'react';
import PopupClose from '../Close';

export default function InfoPopup({title, text, buttonText, buttonType = 'primary', buttonCallback}) {
  return (
    <div className="popup info-popup">
      <div className="popup__close-container"><PopupClose/></div>
      <div className="info-popup__title">{title}</div>
      <div className="info-popup__text">{text}</div>
      <button type="button" className={`btn btn--${buttonType}`} onClick={buttonCallback}>{buttonText}</button>
    </div>
  );
}